import { styled } from "@mui/material";

interface Props {
  column?: true;
}

export const FlexCentered = styled("div", {
  shouldForwardProp: (prop) => prop !== "column",
})<Props>`
  flex: 1 1 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ column }) => (column === true ? "flex-direction: column" : "")}
`;
